<template>
    <div class="mainpage">
        <div ref="leftpage" class="leftpage" v-show="isLeftPageVisible">
            <ul class = "ulstyle">
                <li v-for = "(item,index) in jsonObject" :key="index" :class="{ selected: selectedItem === item }" @click="navigateToDocument(item)">
                    {{ item[0] }}
                </li>
            </ul>
        </div>


        <div class="rightpage">
            <div class = "showindex">
                <button id="showleftpage" @click="toggleLeftPage">
                    <img src="../image/index.png" alt="Toggle Left Page" width="25" height="25" />
                </button>
                <router-view></router-view>
            </div>
            
        </div>
    </div>
</template>

<script>
import jsonData from '@/assets/HTMLIndex.json';

export default {
    data() {
        return {
            // 初始状态根据屏幕宽度来设置
            jsonData:jsonData,
            jsonObject:[],
            isLeftPageVisible: window.innerWidth >= 768,
            selectedItem: null,
        };
    },
    mounted() {
        this.makeIndex(); // 初始化 jsonObject
        window.addEventListener("resize", this.handleResize); // 监听屏幕宽度变化
    },

    beforeUnmount() {
        window.removeEventListener("resize", this.handleResize); // 移除监听器
    },

    methods: {
        makeIndex() {
            this.jsonObject = Object.entries(this.jsonData);
            console.log(this.jsonObject);
        },
        toggleLeftPage() {
            this.isLeftPageVisible = !this.isLeftPageVisible;
        },
        handleResize() {
            this.isLeftPageVisible = window.innerWidth >= 768;
        },
        navigateToDocument(item) {
            this.selectedItem = item;
            const path = item[1];
            this.$router.push(path);
        }
    }

    
};
</script>

<style lang="scss">
    @import './Maincss.scss'
</style>
